




import './KisweButtonGroup.scss'
import { defineComponent } from '@vue/composition-api'
import { useFlexbox } from '@/modules/kisweui/compositions'
import { FlexboxGapSize } from '@/modules/kisweui/types/flexbox'

export default defineComponent({
  name: 'KisweButtonGroup',
  props: {
    gap: useFlexbox({ gap: FlexboxGapSize.XSmall }).props.gap
  }
})
